"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var PreviewStore = __importStar(require("../../app/store/PreviewStore"));
var components_1 = require("../../common/components");
var PreviewTaskContent_1 = __importDefault(require("../preview/components/PreviewTaskContent"));
var actions_1 = require("../../app/store/actions");
var store_1 = require("../../app/store");
var SingleTaskPage = function () {
    var taskId = (0, react_router_1.useParams)().taskId;
    var dispatch = (0, react_redux_1.useDispatch)();
    var task = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.previewStore.details) === null || _a === void 0 ? void 0 : _a[taskId]; });
    var hasLoaded = (0, store_1.useYouwellSelector)(function (state) { return Boolean(state.previewStore.requests["".concat(actions_1.PREVIEW_TASK_RECEIVED, "/").concat(taskId)]
        && state.previewStore.requests["".concat(actions_1.PREVIEW_TASK_RECEIVED, "/").concat(taskId)].completed); });
    (0, react_1.useEffect)(function () {
        if (taskId && !hasLoaded && !task) {
            dispatch(PreviewStore.actionCreators.getElement(taskId));
        }
    }, [dispatch, hasLoaded, task, taskId]);
    if (!task) {
        return hasLoaded ? (React.createElement(components_1.InfoMessage, { messageKey: "noContent" })) : null;
    }
    return (React.createElement(components_1.PageLayout, { title: task.name, task: task },
        React.createElement("div", null,
            React.createElement(PreviewTaskContent_1.default
            // @ts-ignore -- must update PreviewTaskContent to typescript
            , { 
                // @ts-ignore -- must update PreviewTaskContent to typescript
                task: task }))));
};
exports.default = SingleTaskPage;
